import React from 'react';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  variant?: 'default' | 'alternate' | 'transparent' | 'coral' | 'primary';
}

const variantClasses: Record<string, string> = {
  default: 'bg-white',
  alternate: 'bg-slate-50',
  coral: 'bg-coral text-white',
  primary: 'bg-primary text-white',
  transparent: '',
};

export default function Section({
  children,
  className = '',
  id,
  variant = 'default',
}: SectionProps) {
  const bgClass = variantClasses[variant] || '';

  return (
    <section id={id} className={`w-full py-20 md:py-32 ${bgClass} ${className}`}>
      {children}
    </section>
  );
}
